/**
 * 无限滚动
 * @author libaoxu@gaosiedu.com
 * @date 2016-11-1
 */

export default {
  name: 'infinite',

  bind () {

    /*
      1) 如果放入this.scrollHandler, removeEventListener可以找到该方法, 但是不能更改this指向
      2) 如果方式this.scrollHandler.bind(this), 可以更改this指向, 但是removeEventListener不能找到该方法
      3) addEventListener 时候传入 保存的this.scrollBindFunc, 
          这样既可以在addEventListener时: 保存this指向, 
          又能让removeEventListener时: 找到this.scrollBindFunc, 进行解绑
    */
    this.scrollBindFunc = this.scrollHandler.bind(this);

    // 给window添加 scroll事件
    window.addEventListener('scroll', this.scrollBindFunc);

  },

  update (newValue, oldValue) {
    // 底部预留距离
    this.distance = +newValue.distance || +newValue || 0;
  },

  unbind () {
    window.removeEventListener('scroll', this.scrollBindFunc);
  },

  /**
   * window 监听 scroll 滚动事件
   *  注意: this指向不是window, 是Vue.directive(string, definition)的第二个参数: definition
   */
  scrollHandler (e) {
    let body = document.body;

    // 已滚动的距离: (滚动条上border 距离顶部的距离)
    let scrollTop = document.body.scrollTop;

    // 屏幕高度
    let screenHeight = window.screen.height;

    // 准备预留的对底部的距离
    let distance = this.distance;

    // 文档body 总高度
    let bodyHeight = body.clientHeight;
    
    // 满足"三个之和" 大于 "文档总高度" 时, 才触发下拉滚动
    // 大于0 , 是在防止次进入页面时候, 触发
    if (scrollTop > 0 && scrollTop + screenHeight + distance >= bodyHeight) {
      this.vm.infinite && this.vm.infinite(e);
    }
  }
}